import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import styles from './Header.module.css'
import { Button } from '@chakra-ui/react'

interface IUser {
  name: string
  email: string
  picture: string
  roles: string[]
}

export default function Header({ refreshUser }: { refreshUser: () => void }) {
  const [dropdownOpened, setDropdownOpened] = useState(false)
  const [user, setUser] = useState<IUser>({ name: '', email: '', picture: '', roles: [] })
  const navigate = useNavigate()

  const closeDropdown = () => {
    setDropdownOpened(false)
  }

  const logout = () => {
    setDropdownOpened(false)

    localStorage.clear()

    refreshUser()

    navigate('/login')
  }

  useEffect(() => {
    const user = localStorage.getItem('user')

    if (user) {
      setUser(JSON.parse(user))
    }
  }, [])

  return (
    <header className={`${styles.header} mb-3`}>
      <div className={`d-inline-block`}>
        <div className="d-flex flex-row align-items-center">
          <img src={`data:image/png;base64,${user.picture}`} alt="" className={`${styles.profileImage} d-inline`} />
          <span>Bem-vindo(a), {user.name}</span>
          <Button onClick={logout} colorScheme="magenta" size="sm" className="ms-3">
            <i className={`lni lni-exit ${styles.dropdownIcon}`}></i>
            Sair
          </Button>
        </div>
      </div>
    </header>
  )
}
